// extracted by mini-css-extract-plugin
export default {"tip":"styles_tip__zTEZu"};